const isRecord = (value: unknown): value is Record<string, unknown> =>
    typeof value === 'object' && value !== null

export default function buildAdditionalParams(q: unknown): unknown {
    const query = isRecord(q) ? q : {}
    const excluded = new Set(['languageCode', 'line', 'message', 'extra_context_params'])
    const otherParams: Record<string, unknown> = {}
    Object.keys(query).forEach((key) => {
        if (!excluded.has(key)) otherParams[key] = query[key]
    })

    let parsedExtra: unknown = query.extra_context_params
    if (typeof parsedExtra === 'string') {
        try {
            const parsed: unknown = JSON.parse(parsedExtra)
            parsedExtra = parsed
        } catch {
            // leave as string
        }
    }

    // If extra_context_params is an object, merge it with other params (other params override)
    if (parsedExtra && typeof parsedExtra === 'object') {
        return { ...parsedExtra, ...otherParams }
    }

    // If we have other query params, return them as an object (preserve non-JSON extra under a key)
    if (Object.keys(otherParams).length > 0) {
        if (parsedExtra !== undefined && parsedExtra !== null) {
            return { ...otherParams, extra_context_params: parsedExtra }
        }
        return otherParams
    }

    // Fallback to the raw extra value (string) or undefined
    return parsedExtra || undefined
}
